interface SelectAllProps {
  className?: string;
  checked?: boolean;
  selectAll?: React.MouseEventHandler<HTMLDivElement>;
  title?: string;
}

const FilterSelectAll: React.FC<SelectAllProps> = ({ className, checked, selectAll, title }) => {
  return (
    <div className={`option_checkbox ${className}`}>
      <input type="checkbox" checked={checked} readOnly name="checkbox_select_all" />
      <div className="option select_all" onClick={selectAll}>
        {title}
      </div>
    </div>
  );
};

export default FilterSelectAll;
